import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 30000,
});

API.interceptors.request.use(config => {
  const stored = localStorage.getItem('bd_user');
  if (stored) {
    try { config.headers.Authorization = `Bearer ${JSON.parse(stored).token}`; } catch {}
  }
  return config;
});

API.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('bd_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default API;

// ── Auth ──────────────────────────────────────
export const registerUser   = d     => API.post('/auth/register', d);
export const loginUser      = d     => API.post('/auth/login', d);
export const googleAuth     = d     => API.post('/auth/google', d);
export const facebookAuth   = d     => API.post('/auth/facebook', d);
export const getProfile     = ()    => API.get('/auth/profile');
export const updateProfile  = d     => API.put('/auth/profile', d);
export const addAddress     = d     => API.post('/auth/addresses', d);
export const deleteAddress  = id    => API.delete(`/auth/addresses/${id}`);
export const initiatePayment = (orderId) => API.post(`/payment/init/${orderId}`);

// ── Products ──────────────────────────────────
export const getProducts    = p      => API.get('/products', { params: p });
export const getProduct     = id     => API.get(`/products/${id}`);
export const getFeatured    = ()     => API.get('/products/featured');
export const createProduct  = d      => API.post('/products', d);
export const updateProduct  = (id,d) => API.put(`/products/${id}`, d);
export const deleteProduct  = id     => API.delete(`/products/${id}`);
export const addReview      = (id,d) => API.post(`/products/${id}/reviews`, d);

// ── Categories ────────────────────────────────
export const getCategories  = ()     => API.get('/categories');
export const createCategory = d      => API.post('/categories', d);
export const updateCategory = (id,d) => API.put(`/categories/${id}`, d);
export const deleteCategory = id     => API.delete(`/categories/${id}`);

// ── Orders ────────────────────────────────────
export const getShippingConfig = ()     => API.get('/orders/shipping-config');
export const saveDraft         = d      => API.post('/orders/draft', d);
export const createOrder       = d      => API.post('/orders', d);
export const getMyOrders       = ()     => API.get('/orders/myorders');
export const getOrder          = id     => API.get(`/orders/${id}`);
export const payOrder          = (id,d) => API.put(`/orders/${id}/pay`, d);
export const cancelOrder       = (id,d) => API.put(`/orders/${id}/cancel`, d);

// ── Wishlist ──────────────────────────────────
export const toggleWishlist = id => API.post(`/users/wishlist/${id}`);
export const getWishlist    = () => API.get('/users/wishlist');

// ── Banners (public) ──────────────────────────
export const getActiveBanners = () => API.get('/admin/banners/active');

// ── Admin — Dashboard ─────────────────────────
export const getDashboard = () => API.get('/admin/dashboard');

// ── Admin — Orders ────────────────────────────
export const adminGetOrders          = p      => API.get('/admin/orders', { params: p });
export const adminUpdateOrderStatus  = (id,d) => API.put(`/admin/orders/${id}/status`, d);
export const adminUpdateOrderPayment = (id,d) => API.put(`/admin/orders/${id}/payment`, d);

// ── Admin — Draft Orders ──────────────────────
export const adminGetDrafts      = p   => API.get('/admin/drafts', { params: p });
export const adminDeleteDraft    = id  => API.delete(`/admin/drafts/${id}`);
export const adminConfirmDraft   = (id,d) => API.put(`/admin/drafts/${id}/confirm`, d);

// ── Admin — Settings ──────────────────────────
export const getAdminSettings    = (group) => API.get('/admin/settings', { params: { group } });
export const updateAdminSettings = d => API.put('/admin/settings', d);

// ── Admin — Users ─────────────────────────────
export const adminGetUsers   = p      => API.get('/admin/users', { params: p });
export const adminCreateUser = d      => API.post('/admin/users', d);
export const adminUpdateUser = (id,d) => API.put(`/admin/users/${id}`, d);
export const adminDeleteUser = id     => API.delete(`/admin/users/${id}`);
export const adminToggleUser = id     => API.put(`/admin/users/${id}/toggle`);
export const changeUserRole  = (id,r) => API.put(`/admin/users/${id}/role`, { role: r });

// ── Admin — Banners ───────────────────────────
export const adminGetBanners    = ()     => API.get('/admin/banners');
export const adminCreateBanner  = d      => API.post('/admin/banners', d);
export const adminUpdateBanner  = (id,d) => API.put(`/admin/banners/${id}`, d);
export const adminDeleteBanner  = id     => API.delete(`/admin/banners/${id}`);

// ── Admin — Image Upload ──────────────────────
export const uploadImage = d => API.post('/admin/upload', d);

// ── Admin — Coupons ───────────────────────────
export const getCoupons   = ()     => API.get('/admin/coupons');
export const createCoupon = d      => API.post('/admin/coupons', d);
export const updateCoupon = (id,d) => API.put(`/admin/coupons/${id}`, d);
export const deleteCoupon = id     => API.delete(`/admin/coupons/${id}`);
